import React from 'react';

import { FormattedMessage } from 'react-intl';

import { ResultState } from '../../../../../common/ui/result-state';

import NoResultsDark from './assets/no-results-dark.svg';
import NoResultsLight from './assets/no-results-light.svg';
import { messages } from './messages';

export const NoResultsDropdown = (): React.JSX.Element => {
	return (
		<ResultState
			imageSrcLight={NoResultsLight}
			imageSrcDark={NoResultsDark}
			primaryText={<FormattedMessage {...messages.noResultsPrimary} />}
			secondaryText=""
		/>
	);
};
